define(['jquery', 'erv_tracking'], function ($, Tracking) {

	var ERVCampaign = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.tracking = new Tracking();
	};

	ERVCampaign.prototype.init = function () {
		var self = this;

		self.$ervBody.find('.campaign select').on('change', function () {

			if ($(this).val() && $(this).val().replace('\u2212', '\u002D') !== -1) {
				window.location = $(this).val();
			}
		});
	}

	return ERVCampaign;
});